module.exports = __webpack_public_path__ + "assets/187fac2110a3d958f8ed46e336edf2d8.json";